export default {
  'otp.oldPrice': 'Harga asli ',
  'otp.details': 'Detail Acara Gratis Terbatas',
  'otp.effective': 'Waktu Efektif',
  'otp.userTitle': 'Pengguna Preferensial',
  'otp.tip':
    'Jika Anda telah mengisi ulang produk EngageLab lainnya tetapi tidak mengisi ulang OTP, Anda masih dapat berpartisipasi dalam acara ini.',
  'otp.service.dsc': 'Pengguna Pertama Kali Layanan Isi Ulang Produk OTP.',
  'otp.event': 'Acara',
  'otp.tip1a': `Selama periode promosi, pengguna yang mengisi ulang OTP untuk pertama kalinya akan dibebaskan dari biaya verifikasi OTP selama`,
  'otp.tip1b': '30 hari kalender',
  'otp.tip1c': 'dari tanggal isi ulang.',
  'otp.notes1': '1. Satu akun hanya dapat berpartisipasi dalam aktivitas ini sekali.',
  'otp.notes2': `2. Setelah isi ulang selesai, tidak ada pengembalian dana lebih lanjut yang tersedia. Jika Anda memerlukan bantuan lebih lanjut, silakan`,
  'otp.notes2a': 'hubungi kami',
  'otp.notes2b': 'untuk detail.',
  'otp.notes3': `3. EngageLab berhak untuk menyelesaikan interpretasi kampanye dalam lingkup hukum.`,
  'email.sem.title': 'Penawaran Terbatas! 500 Email Gratis/hari untuk Pengguna Baru',
  'email.sem.btn': 'Mulai Sekarang',
};
